module.exports = __webpack_public_path__ + "img/web-open-speed-sdk.63c9d7a.png";